import React from 'react'

export default function CustomersAccountsListInnerStyle({signed_in}) {
  let client_cursor = 'pointer'
  let client_text_color = 'blue'
  if (signed_in !== 'admin') {
    client_cursor = (signed_in.user_access.customers_accounts_fc) ? 'pointer' : 'default'
    client_text_color = (signed_in.user_access.customers_accounts_fc) ? 'blue' : 'black'
  }
  
  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        /** modify parent class table style **/
        /*
        .table thead tr th:nth-child(8) {
          padding: 0;
          text-align: left;
        }
        .table tbody tr td:nth-child(8) {
          padding: 0;
          text-align: left;
        }
        */

        .table tbody tr:hover {
          background-color: transparent;
          color: ${client_text_color};
          cursor: ${client_cursor};
        }

        .client-checkbox {
          margin-top: 13px;
          padding: 0;
        }

        #select-all-btn {
          margin-top: 13px;
          padding: 0;
        }
        #select-all-btn:hover, #select-all-btn:focus {
          background-color: transparent;
          color: black;
        }

        .customer-accounts-list-container {
          display: flex;
          flex-direction: column;
          justify-content: stretch;
          font-size: 0.65em;
          border: solid 0.5px lightgrey;
          /*padding: 5px;*/
        }

        .edit-customer-account-details-btn {
          color: blue;
          border: none;
          background-color: transparent;
        }
        .edit-customer-account-details-btn:hover {
          text-decoration: underline;
          cursor: pointer;
        }

        .title-header { display: flex; }
        .title-header:hover { cursor: default; }
        .title-header div { flex: 2; }
        .title-header span { text-align: right; }
      `}
      </style>
    </React.Fragment>
  )
}
